import { ITranslations } from 'types/common';
import { EditParserTransFields } from './types';
import en from 'translations/en/editParser.json';
import pl from 'translations/pl/editParser.json';
import sl from 'translations/sl/editParser.json';

export const editParserTranslations: ITranslations<EditParserTransFields> = {
  name: 'editParser',
  en,
  pl,
  sl,
};
